import { render, staticRenderFns } from "./AuthBackLink.vue?vue&type=template&id=0e1f854c&scoped=true&"
import script from "./AuthBackLink.vue?vue&type=script&lang=js&"
export * from "./AuthBackLink.vue?vue&type=script&lang=js&"
import style0 from "./AuthBackLink.vue?vue&type=style&index=0&id=0e1f854c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1f854c",
  null
  
)

export default component.exports